function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atom-image-search_inline_svg__ycvbulbj9a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.678431 0 0 0 0 0.776471 0 0 0 0 0.792157 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#atom-image-search_inline_svg__ycvbulbj9a)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.099 12.346A19.753 19.753 0 1118.13 18.13a19.622 19.622 0 0113.97-5.784M32.1 0C14.37 0 0 14.37 0 32.099c0 17.728 14.37 32.099 32.099 32.099 17.728 0 32.099-14.37 32.099-32.1C64.198 14.37 49.828 0 32.098 0z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.917 73.565l-4.368 4.367a3.688 3.688 0 01-5.231 0L52.932 62.546a3.704 3.704 0 01-1.08-2.623v-2.516l5.555-5.555h2.516a3.704 3.704 0 012.623 1.08l15.386 15.386a3.72 3.72 0 01-.015 5.247z"
})));

function SvgAtomImageSearchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
}

export default SvgAtomImageSearchinline;